import http from "infra/http";
import { useMutation } from "react-query";
import URL from "core/resources/urls";

export default function useDeleteJobs() {
  return useMutation(
    URL.RECURRING_JOB_GROUP.DELETAR("id"),
    async (id: string) => {
      const response = await http.delete(URL.RECURRING_JOB_GROUP.DELETAR(id));
      return response;
    },
  );
}
